import Web3 from 'web3'
import 'core-js/modules/es.promise.finally'

export default Web3
